import { useServicesBillingDetails } from "./useServicesBillingDetails.tsx";
export const useServiceBillingDetails = _ref => {
  let {
    service,
    relationshipEffectiveDate,
    enabled = true
  } = _ref;
  const {
    servicesBillingDetails,
    isFetching
  } = useServicesBillingDetails({
    services: [service],
    relationshipEffectiveDate,
    enabled
  });
  const serviceBillingDetails = servicesBillingDetails[service.id];
  return {
    periods: serviceBillingDetails === null || serviceBillingDetails === void 0 ? void 0 : serviceBillingDetails.periods,
    nextBillingDate: serviceBillingDetails === null || serviceBillingDetails === void 0 ? void 0 : serviceBillingDetails.nextBillingDate,
    isFetching
  };
};